import React, {useCallback, useMemo} from 'react';
import {useField} from 'formik';
import {InputProps} from 'antd/es/input';
import {Input} from 'formik-antd';
import {sanitizeUrl} from '@braintree/sanitize-url';

export const UrlInput: React.FC<{name: string} & InputProps> = ({name, ...inputProps}) => {
  const [field, , {setValue}] = useField(name);
  const value = useMemo(() => field.value?.replace('https://', ''), [field.value]);

  const onChange = useCallback(
    (value: string) => {
      const sanitized = value ? sanitizeUrl(value) : '';
      if (!sanitized) return setValue(null);
      setValue('https://' + sanitized);
    },
    [setValue]
  );

  return (
    <Input
      addonBefore="https://"
      {...field}
      {...inputProps}
      value={value || undefined}
      onChange={(e) => onChange(e.target.value)}
    />
  );
};
